<template>
  <div>
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader class="d-flex justify-content-between">
            <b><i class="fas fa-calendar"></i>&nbsp;Ventas</b>
          </CCardHeader>
          <CRow class="d-flex justify-content-center">
            <CCol xs="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-content-center mt-2">
              <CButton @click="showSalesTable = true" :style="{
                backgroundColor: showSalesTable ? '#00003a' : '#aab0b6',
                borderColor: showSalesTable ? '#00003a' : '#aab0b6',
                color: 'white',
              }" class="mt-2 w-75 custom-button">
                Citas
              </CButton>
            </CCol>
            <CCol xs="12" sm="6" md="6" lg="6" xl="6" class="d-flex justify-content-center mt-2">
              <CButton @click="showSalesTable = false" :style="{
                backgroundColor: !showSalesTable ? '#00003a' : '#aab0b6',
                borderColor: !showSalesTable ? '#00003a' : '#aab0b6',
                color: 'white',
              }" class="mt-2 w-75 custom-button">
                Productos
              </CButton>
            </CCol>
          </CRow>
          <hr />
          <CCardBody>
            <CRow>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                  v-model="filter.init" />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput label="Hasta" type="date" aria-label="shift_date" @input="mtd_data" id="end" size="sm"
                  v-model="filter.end" />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput label="Cantidad de Ventas" type="text" size="sm" v-model="totalVentas" disabled />
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="12">
                <CInput label="Total de Ventas" type="text" size="sm" v-model="sumaTotalVentas" disabled />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <!-- Tabla de Ventas x Citas -->
        <CTableWrapper v-if="showSalesTable" :items="data_sale_quotes" :fields="fields" hover :striped="true"
          :border="true" small fixed caption="Lista de ventas de citas" icon="fas fa-coins" @mtdBack="mtdBack"
          :size="'md'" :withActions="'2%'" :actions="true" :myButtons="myButtons" @mtd_ticket="mtd_ticket" />
        <!-- Tabla de Ventas x producto -->
        <CTableWrapper v-else :items="data_sale_products" :fields="sale_products" hover :striped="true" :border="true"
          small fixed caption="Lista de ventas de productos" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'"
          :withActions="'2%'" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "client_name", label: "Cliente", _style: "width:10%;" },
  { key: "detail_barber", label: "Personal", _style: "width:5%;" },
  { key: "date_formatted", label: "Fecha Venta", _style: "width:10%;" },
  { key: "data_formatted_quote", label: "Fecha Cita", _style: "width:10%;" },
  { key: "services", label: "Sevicios", _style: "width:10%;" },
  {
    key: "detail_service",
    label: "Detalles del servicio",
    _style: "width:10%;",
  },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "subtotal", label: "SubTotal", _style: "width:5%;" },
  { key: "ajustment_amount", label: "Aumento /Descuento", _style: "width:5%;" },
  { key: "amount", label: "Monto", _style: "width:5%;" },
  { key: "alltotal", label: "Total", _style: "width:5%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

const sale_products = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "client_name", label: "Cliente", _style: "width:10%;" },
  { key: "date_formatted", label: "Fecha", _style: "width:10%;" },
  { key: "method_payment_text", label: "Método de pago", _style: "width:10%;" },
  { key: "subtotal", label: "SubTotal", _style: "width:5%;" },
  { key: "ajustment_amount", label: "Aumento /Descuento", _style: "width:5%;" },
  { key: "amount", label: "Monto", _style: "width:5%;" },
  { key: "alltotal", label: "Total", _style: "width:5%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../components/shared/datatable/Table.vue";
import { mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "sales",
      fields,
      sale_products,
      totalVentas: 0,
      sumaTotalVentas: 0,
      data: [],
      data_sale_quotes: [],
      data_sale_products: [],
      filter: {
        init: null,
        end: null,
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      showSalesTable: true,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "Ticket",
          action: "mtd_ticket",
          icon: "fas fa-file-pdf",
        },
      ],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.companies.state == 1) return true;
      return false;
    },
  },
  created() {
    moment.locale("es");
    this.filter.end = moment().format("YYYY-MM-DD");
    this.filter.init = this.filter.end;
    this.mtd_data();
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtd_data() {
      if (
        !this.filter.init ||
        !this.filter.end ||
        this.filter.init > this.filter.end
      ) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Por favor, selecciona un rango de fechas válido.",
        });
      }
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/indexSale",
        token: this.$store.getters.get__token,
        params: {
          init: this.filter.init,
          end: this.filter.end,
          campu_id: this.$store.getters.get_campu.id,
        },
      })
        .then((response) => {
          this.data = response.data;
          this.data_sale_quotes = this.data.filter((item) => item.type == 1);
          this.data_sale_products = this.data.filter((item) => item.type == 0);

          this.totalVentas = this.data.length;
          this.sumaTotalVentas = this.data
            .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
            .toFixed(2);

          let index = 1;
          this.data.forEach((item) => {
            item.subtotal = item.total;
            item.alltotal = (parseFloat(item.total) + parseFloat(item.ajustment_amount)).toFixed(2);
            item.index = index++;
            item.client_name = item.client?.name || "No especificado";
            item.detail_barber =
              item.quote?.[0]?.barber_detail?.length > 0
                ? item.quote[0].barber_detail
                  .map((det) =>
                    det.barber
                      ? det.barber.name + " " + det.barber.last_name
                      : "Personal desconocido"
                  )
                  .join(", ")
                : item.barber?.name
                  ? item.barber.name + " " + item.barber.last_name
                  : "Personal desconocido";
            item.date_formatted = moment(item.date).format("DD/MM/YYYY");
            item.data_formatted_quote = moment(item.quote[0]?.date).format("DD/MM/YYYY");
            let services = item.quote?.[0]?.detail?.map((detail) => detail.name_service);
            if (item.quote?.[0]?.detail_product) {
              let detailProduct = JSON.parse(item.quote?.[0]?.detail_product);
              let productNames = detailProduct.map(product => product.name);
              services = services.concat(productNames);
            }
            item.services = Array.isArray(services) ? services.join(", ") : "No especificado";


            const hasBarberDetail = Array.isArray(item.quote?.[0]?.barber_detail)
              ? item.quote[0].barber_detail.length
              : 0;

            if (item.quote?.[0]?.detail_service == null && hasBarberDetail == 0 && item.type == 1) {
              item.detail_service = "No detallado";
            } else if (item.quote?.[0]?.detail_service != null && hasBarberDetail == 0 && item.type == 1) {
              item.detail_service = item.quote[0]?.detail_service ?? "No detallado";
            } else if (item.quote?.[0]?.detail_service != null && hasBarberDetail >= 0 && item.type == 1) {
              item.detail_service = item.quote?.[0]?.detail_service ?? "No detallado";
            } else if (item.quote?.[0]?.detail_service == null && hasBarberDetail >= 0 && item.type == 1 ) {
              item.detail_service = item.quote?.[0]?.barber_detail.map((detail) => detail.detail_service).join(", ");
            }
            
            if (item.method_payment && item.method_payment?.name) {
              item.method_payment_text = item.method_payment.name;
            } else {
              item.method_payment_text = "No especificado";
            }
            switch (item?.state) {
              case 0:
                item.status = "Cancelado";
                break;
              case 1:
                item.status = "Pagado";
                break;
              case 2:
                item.status = "Pendiente";
                break;
              default:
                item.status = "Desconocido";
            }
          
          });
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_ticket(item) {
      if (item?.voucher?.[0]?.id && item?.voucher?.[0]?.detail) {
        const voucher = item.voucher[0].id;
        const quote = item.voucher[0].detail;
        const document_name = item.voucher[0].document_type.name;
        if (document_name == "NOTA DE VENTA") {
          window.open(
            this.$store.getters.get__url +
            "/cita/ticket/" +
            voucher +
            "/" +
            quote +
            "/" +
            this.$store.getters.get__user_id,
            "_blank"
          );
        } else {
          const sunatData = JSON.parse(item.voucher[0].sunat);
          const ticketUrl = sunatData?.json?.enlace_del_pdf_ticket;
          window.open(ticketUrl, "_blank");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Ticket",
          text: "Está cita todavía no tiene documento",
        });
      }
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-button:hover {
  background-color: #7e4bbf !important;
  border-color: #7e4bbf !important;
}
</style>